module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/nb_hours_selection/Medium-6b7172b388da895b5ae5e1c3a571c009.svg";